import { lazy } from 'react';

export const MainPage = lazy(() => import('./main'));
export const CampaignFormPage = lazy(() => import('./campaign'));
export const EmbedPage = lazy(() => import('./embed'));
export const StatisticsPage = lazy(() => import('./statistics'));
export const CouponsPage = lazy(() => import('./coupons'));
export const AccountPage = lazy(() => import('./account'));
export const SignInPage = lazy(() => import('./sign-in'));
export const CodePage = lazy(() => import('./code'));
export const UserWidgetPage = lazy(() => import('./user-widget'));
